import React from "react";

import RootProf from "./RootProf";
import RootEleve from "./RootEleve";
import RootChef from "./RootChef";

import { useUser } from "../context/UserContext";

/**
 * Accueil (`/home/`) : aiguillage par rôle.
 *
 * Plus de popup « devenir scanner ou projection » (chantier jeton,
 * 2026-09-04) : le téléphone se relie à une séance en scannant le QR projeté,
 * il n'entre plus par l'accueil.
 */
function Root() {
    const { user} = useUser();

    const role = user && user.role

      // If role is not 'eleve', render the RootProf component
      if (role === "professeur") {
          return <RootProf />;
      }
      else if(role ==="eleve") {
        return <RootEleve  />
      }
      else if(role ==='chef' ){
        return <RootChef  />
      }

  // Return null or a loading indicator as the navigation will be handled by the useEffect hook
  return null;
}

export default Root;
